module.exports = __webpack_public_path__ + "img/Welzijn.ee3c14e9.webp";